const RESOURCE_NAME = '/shipments-templates';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
});